import { render, staticRenderFns } from "./IconsSettings.vue?vue&type=template&id=7ceb7816&scoped=true&"
import script from "./IconsSettings.vue?vue&type=script&lang=js&"
export * from "./IconsSettings.vue?vue&type=script&lang=js&"
import style0 from "./IconsSettings.vue?vue&type=style&index=0&id=7ceb7816&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ceb7816",
  null
  
)

export default component.exports